module.exports = __webpack_public_path__ + "img/_2.38cfa6a9.png";